export default __webpack_public_path__ + "static/media/users_1.78cef95b.png";